import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import RightScenes from "../components/Menu/BarDashboard/RightScenes/RightScenes";
import CardProfile from "./components/CardProfile";
import CardAccountSecurity from "./components/CardAccountSecurity";
import CardEntitiesAndLoans from "./components/CardEntitiesAndLoans";

interface ProfileProps {
  ProfileViewContext: any;
  EntitiesViewContext: any;
  LoansViewContext: any;
}

const Profile = ({ ProfileViewContext, EntitiesViewContext, LoansViewContext }: ProfileProps) => {
  const location = useLocation();
  const { visible, setHandlerVisible }: any = useContext(ProfileViewContext);

  useEffect(() => {
    if (location.pathname === '/profile') {
      setHandlerVisible(true);
    }
  }, [location.pathname, setHandlerVisible]);

  return (
    <RightScenes
      visible={visible}
      handlerSetVisibile={setHandlerVisible}
    >
      <div className="view-profile">
        <div className='view-profile-header'>
          <h1 className='title'>Profile and Settings</h1>
        </div>
        <div className="flex-2-col">
          <div className="box box-left">
            {/*<CardProfileNotifications />*/}
            <div className="profile-card-wrapper profile-card-account-security">
              <CardAccountSecurity />
            </div>
            <div className="profile-card-wrapper profile-card-entities-loans">
              <CardEntitiesAndLoans 
                EntitiesViewContext={EntitiesViewContext} 
                LoansViewContext={LoansViewContext} 
                ProfileViewContext={ProfileViewContext} 
              />
            </div>
          </div>
          <div className="box box-right">
            <div className="profile-card-wrapper profile-card-profile">
              <CardProfile />
            </div>
            {/*<div className="flex-center">
              <Button className="button-r">
                BROKER
              </Button>
              <Button className="button-delete">
                if broker use this tag
              </Button>
            </div>*/}
          </div>
        </div>
      </div>
    </RightScenes>
  );
}

export default Profile;